import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Header from "./Header";
import Footer from "./Footer";
import PathwayCard from "./PathwayCard";
import { hero, organisation, professional } from "../mock";

const LandingPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleAction = (id) => {
    switch (id) {
      case "post-requirement":
        navigate(user?.role === "organisation" ? "/post-requirement" : "/register");
        break;
      case "browse-professionals":
        navigate("/professionals");
        break;
      case "find-opportunities":
        navigate("/opportunities");
        break;
      case "tell-us":
        navigate("/tell-us");
        break;
      default:
        navigate("/");
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-white font-body md:h-screen md:overflow-hidden">
      <Header />

      {/* Hero + pathways fill remaining viewport */}
      <section className="relative flex flex-1 flex-col md:overflow-hidden bg-gradient-to-b from-[#f5f9fd] via-[#f4faf6] to-white">
        <div className="mx-auto w-full max-w-[1200px] px-6 pb-2 pt-4 sm:pt-6 lg:px-8">
          <div className="relative">
            {/* Script accent top-right */}
            <div className="pointer-events-none absolute right-0 top-0 hidden text-right xl:block">
              <div className="font-script text-[28px] font-bold leading-[0.9] text-[#1E4FA3] -rotate-6">
                {hero.script.map((line, i) => (
                  <div key={i}>{line}</div>
                ))}
              </div>
              <svg width="140" height="13" viewBox="0 0 140 13" className="ml-auto mt-1">
                <path
                  d="M2 8 C 38 2, 104 2, 138 7"
                  stroke="#16A34A"
                  strokeWidth="3"
                  fill="none"
                  strokeLinecap="round"
                />
              </svg>
            </div>

            <div className="mx-auto max-w-4xl text-center">
              <p className="text-[11px] font-semibold tracking-[0.2em] text-[#1E4FA3] sm:text-[13px] sm:tracking-[0.22em]">
                {hero.eyebrow}
              </p>
              <h1 className="mt-2 font-heading text-[30px] font-extrabold leading-[1.05] tracking-tight text-[#0B2545] sm:text-[44px] lg:whitespace-nowrap">
                {hero.titleLead} <span className="text-[#16A34A]">{hero.titleAccent}</span>
              </h1>
              <p className="mx-auto mt-2 max-w-3xl text-[14px] leading-relaxed text-slate-600 sm:text-[17px]">
                {hero.subtitle}
              </p>
            </div>
          </div>
        </div>

        {/* Two pathways */}
        <div className="mx-auto flex w-full max-w-[1200px] flex-1 items-center px-4 pb-4 pt-3 sm:px-6 lg:px-8">
          <div className="relative grid w-full grid-cols-1 gap-4 md:grid-cols-2 lg:gap-6">
            <PathwayCard data={organisation} theme="blue" onAction={handleAction} />
            <PathwayCard data={professional} theme="green" onAction={handleAction} />

            {/* 'or' divider badge */}
            <div className="absolute left-1/2 top-1/2 z-10 hidden -translate-x-1/2 -translate-y-1/2 md:block">
              <div className="flex h-12 w-12 items-center justify-center rounded-full border border-slate-100 bg-white text-[14px] font-semibold text-slate-500 shadow-md">
                or
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LandingPage;
